import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';
import {IOperateurService} from '../../../../../core/services/operateur.service';

interface IPagePI0005 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Pi0005Controller(Menu: IMenuClass,
                                         Operateur: IOperateurService) {
    const vm: IPagePI0005 = this;

    vm.multiOccurrenceOptions = {
        //navigatePage: ????Route.NAME,
        actionsNouveaux: new Menu([]),
        filtres: [
            {
                colonne: 'trnflgstaann',
                operateur: Operateur.EGALE_PAS,
                valeur: '1'
            },
            {
                colonne: 'trnflgstafer',
                operateur: Operateur.EGALE,
                valeur: ''
            }
        ],
        colonnesVisibles: [
            {nom: 'pipnumdoc', largeur: 200},
            {nom: 'pipnumref', largeur: 200},
            {nom: 'ecldsceta', largeur: 200},
            {nom: 'pipdsc', largeur: 200},
            {nom: 'datdeb', largeur: 200},
            {nom: 'datfin', largeur: 200},
            {nom: 'datrec', largeur: 200},
            {nom: 'pipflgpdi', largeur: 200},
            {nom: 'ptycod', largeur: 200},
            {nom: 'ptydsc', largeur: 200},
            {nom: 'pipdscabr', largeur: 200},
            {nom: 'pphnumdoc', largeur: 200},
            {nom: 'pphdscl01', largeur: 200},
            {nom: 'pipflgpphexc', largeur: 200},
            {nom: 'pplnumdoc', largeur: 200},
            {nom: 'ppldscl01', largeur: 200},
            {nom: 'pipflgpplexc', largeur: 200},
            {nom: 'trnflgstaref', largeur: 200},
            {nom: 'trnflgstafin', largeur: 200},
            {nom: 'trnflgstafer', largeur: 200},
            {nom: 'trnflgstaann', largeur: 200}
        ]
    };
}
